
import {OlServiceModel} from "@/modules/ol/service/ol-service-model";
import {OlService} from "@/modules/ol/service/ol-service";
import {initMap} from "@/helpers/ol/ol-map-helper";
import {updateActiveLayer} from "@/modules/ol/ol-background-switcher";
import {addLayer} from "@/helpers/ol/ol-layer-helper";
import {setActiveFilter} from "@/helpers/filter/filter-helper";
import {getActiveSession} from "@/helpers/user-session-helper";

export class OlComponent extends HTMLElement {
    constructor() {
        super();

        // Make map global
        initMap(this)

        document.getElementsByClassName('ol-compass')[0].innerHTML = ''
        // let service = new OlServiceModel(1, 'OSM');
        // let olService = new OlService(service);

        if(window.settings.backgroundLayers.length > 0) {
            let layer

            if(window.urlParamsObject.aan || window.urlParamsObject.bookmarkpresentatieids) {

                let presentationNames
                if(window.urlParamsObject.aan) {
                    presentationNames = window.urlParamsObject.aan.split(',')
                } else {
                    presentationNames = window.urlParamsObject.bookmarkpresentatieids.split(',')
                }

                window.settings.backgroundLayers.map((backgroundLayer) => {

                    presentationNames.map(presentationName => {
                        if(parseInt(presentationName)) {
                            if(parseInt(presentationName) === backgroundLayer.BookmarkPresentationID) {
                                layer = backgroundLayer
                            }
                        } else {
                            if(presentationName === backgroundLayer.DisplayName) {
                                layer = backgroundLayer
                            }
                        }
                    })
                })

                if(window.urlParamsObject.catalogus) {
                    const input = document.querySelector('layer-menu-switcher-button-active input')
                    if(window.urlParamsObject.catalogus === '1') {
                        if(input.checked) {
                            input.click()
                        }
                    } else {
                        if(!input.checked) {
                            input.click()
                        }
                    }
                }
            } else {
                const layerChecked = window.settings.backgroundLayers.find(layer => layer.Checked)
                if(layerChecked) {
                    layer = layerChecked
                } else {
                    layer = window.settings.backgroundLayers[0]
                }
            }

            if(layer) {

                const activeSession = getActiveSession()
                if(activeSession) {
                    activeSession.user_session_bookmark_presentations.map((userSessionBookmarkPresentation) => {
                        let backgroundLayer = window.settings.backgroundLayers.find(backgroundLayer => backgroundLayer.BookmarkPresentationID === userSessionBookmarkPresentation.BookmarkPresentationID)
                        if (backgroundLayer) {
                            layer = backgroundLayer
                        }
                    })
                }

                window.activeBookmarkPresentationID = String(layer.BookmarkPresentationID)
                if(layer.BookmarkGroupID) {
                    window.settings.backgroundLayers.filter(backgroundLayer => backgroundLayer.BookmarkGroupID === layer.BookmarkGroupID).map((layer) => {
                        addLayer(layer.BookmarkPresentationID, true, true)
                    })

                    window.activeBookmarkGroupdID = layer.BookmarkGroupID
                } else {
                    let service = new OlServiceModel(window.activeBookmarkPresentationID, layer);
                    let olService = new OlService(service);
                    olService.addLayer(window.map)
                }

                if(window.urlParamsObject.aan || window.urlParamsObject.bookmarkpresentatieids) {
                    updateActiveLayer()
                }
            }
        }
    }
}
